import { Flex, Spinner, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import React from 'react';

// Indeterminate loading state for non-PDF previews (CSV / Markdown / TXT) whose content is
// fetched async — so a heavy/slow file shows a clear "loading" state instead of a blank panel.
const PreviewLoading = () => (
  <Flex align='center' justify='center' direction='column' gap={4} w='100%' h='100%' bg='bg.canvas'>
    <Spinner
      color='primary.solid'
      emptyColor='border.default'
      size='lg'
      speed='0.7s'
      thickness='3px'
    />
    <Text color='text.muted' fontSize='sm' fontWeight={500}>
      {t('common.loadingFile')}
    </Text>
  </Flex>
);

export default PreviewLoading;
